(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eclat-cart-assist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ec-cart-assist')) {
  customElements.define('ec-cart-assist', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.suggestions !== 'page') return;
      this.abort = new AbortController();
      this.loadSuggestions();
    }
    disconnectedCallback() { this.abort?.abort(); }
    async loadSuggestions() {
      try {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('section_id', 'eclat-cart-suggestions');
        url.searchParams.set('product_id', this.dataset.product);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'related');
        const response = await fetch(url, {signal:this.abort.signal});
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const existing = new Set(this.dataset.items.split(','));
        const products = [...doc.querySelectorAll('[data-suggestion-product]')].filter(el => !existing.has(el.dataset.suggestionProduct)).slice(0,2);
        const heading = doc.querySelector('[data-suggestion-heading]');
        const target = this.querySelector('.ec-cart-assist__suggestions');
        if (!products.length || !heading || !target || !this.isConnected) return;
        target.replaceChildren(heading, ...products);
        target.hidden = false;
      } catch (error) { if (error.name !== 'AbortError') this.querySelector('.ec-cart-assist__suggestions')?.setAttribute('hidden',''); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eclat-header-pro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const header = document.querySelector('.ec-head');
    if (!header) return;
    if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
    if (event.target.closest('.ec-head__nav a')) header.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
    const summary = event.target.closest('.ec-head__dropdown > summary');
    if (summary) header.querySelectorAll('.ec-head__dropdown[open]').forEach((detail) => { if (detail !== summary.parentElement) detail.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = document.querySelector('.ec-head');
    if (!header) return;
    const mobileMenu = header.querySelector('.ec-head__mobile-menu[open]');
    const opened = mobileMenu || header.querySelector('.ec-head__dropdown[open]');
    header.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
    if (opened) opened.querySelector('summary').focus();
  });
  } catch(e) { console.error(e); }
})();

})();
